import client from '../httpClient';

// 【mokuhyoMst002】キマリス目標登録
const createKimarisTarget = (params) => {
  return client.post('/keymalis-target-settings/', JSON.stringify(params));
};

export default createKimarisTarget;
